
import {getCookie} from 'cupshe-utils';
export const handleDefaultSiteConfig = () =>{
  try {
    const site = localStorage.getItem("__CUPSHE_SITE__"); 
    if(site && site !== "{}" && site !== "null" && site !== "undefined" ) {
      return JSON.parse(decodeURIComponent(site));
    } else if(window.__CUPSHE__ && window.__CUPSHE__.site ) {
      return window.__CUPSHE__.site;  
    } else {
      const storeSite = getCookie("__CUPSHE_SITE__");
      return storeSite ? JSON.parse(decodeURIComponent(storeSite)) : {};
    }
  
  } catch (error) {
    return window.__CUPSHE__.site;
  }
};